import LeaveCSVPreviewColumnsStrategy from './LeaveCSVPreviewColumnsStrategy'

export default function LeaveCSVPreviewLeaveTimeOnlyStrategy() {}

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype = new LeaveCSVPreviewColumnsStrategy();

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype.init = function ()
{
    LeaveCSVPreviewColumnsStrategy.prototype.init.call( this );
    return this;
};

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype.getNumOfDataColumns = function ()
{
    return 4;
};

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.addLeaveTypeTotalCell(mainHeaderRow);
    this.addLeaveTypeCells( mainHeaderRow, this.getNumOfDataColumns()  - 1);
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewTimeOnlyStrategy.js